import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=7f4485ba&scoped=true&lang=html&"
import script from "./photos.vue?vue&type=script&lang=js&"
export * from "./photos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4485ba",
  null
  
)

export default component.exports